function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 0H1.25C0.918479 0 0.600537 0.131696 0.366116 0.366116C0.131696 0.600537 0 0.918479 0 1.25V11.25C0 11.5815 0.131696 11.8995 0.366116 12.1339C0.600537 12.3683 0.918479 12.5 1.25 12.5H16.25C16.5815 12.5 16.8995 12.3683 17.1339 12.1339C17.3683 11.8995 17.5 11.5815 17.5 11.25V1.25C17.5 0.918479 17.3683 0.600537 17.1339 0.366116C16.8995 0.131696 16.5815 0 16.25 0ZM14.875 1.25L8.75 5.4875L2.625 1.25H14.875ZM1.25 11.25V1.81875L8.39375 6.7625C8.49837 6.83508 8.62267 6.87397 8.75 6.87397C8.87733 6.87397 9.00163 6.83508 9.10625 6.7625L16.25 1.81875V11.25H1.25Z"
});

var SvgEmailIcon = function SvgEmailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    fill: "none",
    viewBox: "0 0 18 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-icon.8dc1e138.svg";
export { ForwardRef as ReactComponent };